import { useTranslation } from "react-i18next";

export function useLanguageOptions() {
  const { t } = useTranslation();

  const options = [
    {
      value: "en-GB",
      text: t("Language.EN_GB"),
    },
    {
      value: "de-AT",
      text: t("Language.DE_AT"),
    },
    //
    {
      value: "bg-BG",
      text: t("Language.BG_BG"),
    },
    {
      value: "ro-RO",
      text: t("Language.RO_RO"),
    },
    {
      value: "pl-PL",
      text: t("Language.PL_PL"),
    },
    {
      value: "hu-HU",
      text: t("Language.HU_HU"),
    },
    {
      value: "lt-LT",
      text: t("Language.LT_LT"),
    },
    {
      value: "sr-Latn-RS",
      text: t("Language.SR_RS"),
    },
  ];
  return options;
}
